import { useFetchWrapper } from "../hooks/useFetchWrapper";
import { useLoading } from "../utils/LoadingContext";
import {
    formatAPIErrorLog,
    formatAPIResponseLog,
    getFormattedCurrentTime,
    notifyError,
    notifySuccess
} from "../utils/helpers";
import {
    GEN_AI_INVALID_INST_ERROR,
    GEN_AI_INVALID_VIDEO_ERROR, GEN_AI_INVALID_VIDEO_FILE_TOO_LARGE_ERROR,
    GEN_AI_INVALID_VIDEO_LINK_DOMAIN_ERROR,
    GEN_AI_INVALID_VIDEO_LINK_ERROR,
    GENERATE_QUESTION_ERROR,
    LOAD_PLATFORM_SETTINGS_ERROR,
    LOAD_SSO_ERROR,
    SERVER_ERROR,
    SSO_UPDATE_SUCCESS,
    UPDATE_LMS_ERROR,
    UPDATE_LMS_SUCCESS,
    UPDATE_PLATFORM_SETTINGS_ERROR
} from "../utils/toast-message-constants";
import {useConfig} from "../hooks/useConfig";

export const InstitutionApiCalls = () => {
    const fetchWrapper = useFetchWrapper();
    const config = useConfig();
    const {setLoading} = useLoading();
    return {
        loadInstitution,
        pingInstitution,
        loadInstitutions,
        checkNameExited,
        checkDomainExited,
        saveInstitution,
        listYuJaAccount,
        listEventBanners,
        saveEventBanner,
        deleteEventBanner,
        listTimeZone,
        uploadImg,
        uploadLogoImg,
        saveSSODetails,
        getSSODetails,
        saveLMSConfig,
        getSetting,
        updateSetting,
        questionGenerate,
        batchUpdateAdminManagers,
        getSupportCode,
    }


    function loadInstitution (instId) {
        return fetchWrapper.get({url: `${config.api.institution}/institution/details/${instId}`})
            .then((res) => {
                if (res.success) {
                    return res.result;
                } else {
                    notifyError(res.errorMessage);
                    return null;
                }
            }, (err) => {
                notifyError("Can not load institutions now. Please try again later.");
                console.log(err);
                return null;
            });
    }




    function pingInstitution(shortName) {
    const fullUrl = `https://${shortName}.${config.host_url}`;

        return fetch(fullUrl, {
            mode: 'no-cors',
            cache: 'no-cache'
        }).then(() => {
            return true;
        }).catch(err => {
            return false;
        }) ;

        // return fetchWrapper.put({
        //     url: `${config.api.institution}/institution/${shortName}/ping`,
        // }).then(
        //     (res) => {
        //         if (res.success) {
        //             return res.result;
        //         } else {
        //             console.log(res);
        //             return false;
        //         }
        //     },
        //     (error) => {
        //         console.log(error);
        //         return false;
        //     }
        // ).catch(e => {
        //     console.log(e);
        //     return false;
        // });
    }

    function loadInstitutions () {
        return fetchWrapper.get({url: `${config.api.institution}/institutions`})
            .then((res) => {
                if (res.success) {
                    return res.result;
                } else {
                    notifyError(res.errorMessage);
                    return [];
                }
            }, (err) => {
                notifyError("Can not load institutions now. Please try again later.");
                console.log(err);
                return [];
            });
    }


    function checkDomainExited(shortName) {
        let url = `${config.api.institution}/institution/domain/existed?shortName=${shortName}`
        return fetchWrapper.get({url: url})
            .then((res) => {
                    if (res.success) {
                        return res.result;
                    } else {
                        notifyError(res.errorMessage);
                        return null;
                    }
                },
                (error) => {
                    notifyError("Could not verify domain now. Please try again later.");
                    console.log(error);
                    return null;
                }
            );
    }


    function checkNameExited({fullName, shortName}) {
        let url;
        if (fullName && shortName) {
            url = `${config.api.institution}/institution/existed?fullName=${fullName}&shortName=${shortName}`
        } else if (fullName) {
            url = `${config.api.institution}/institution/existed?fullName=${fullName}`
        } else {
            url = `${config.api.institution}/institution/existed?shortName=${shortName}`
        }

        return fetchWrapper.get({url: url})
            .then((res) => {
                    if (res.success) {
                        return res.result;
                    } else {
                        notifyError(res.errorMessage);
                        return true;
                    }
                },
                (error) => {
                    notifyError("Can not check institution now. Please try again later.");
                    console.log(error);
                    // throw new Error(error);

                    return true;
                }
            );
    }


    function saveInstitution(institutionObj, isNew) {
        if (isNew) {
            return fetchWrapper.post({
                url: `${config.api.institution}/institution`,
                body: institutionObj
            }).then(
                (res) => {
                    if (res.success) {
                        return res.success;
                    } else {
                        notifyError(res.errorMessage);
                        console.log(res);
                    }
                    return res.result;
                },
                (error) => {
                    notifyError("Can not save institutions now. Please try again later.");
                    console.log(error);
                    return null;
                }
            ).catch(e => {
                notifyError("Can not save institutions now. Please try again later.");
                console.log(e);
                return null;
            });
        } else {
            return fetchWrapper.put({
                url: `${config.api.institution}/institution/${institutionObj.code}`,
                body: institutionObj
            }).then(
                (res) => {
                    if (res.success) {
                        return res.success;
                    } else {
                        notifyError(res.errorMessage);
                        console.log(res);
                    }
                    return res.success;
                },
                (error) => {
                    notifyError("Can not save institutions now. Please try again later.");
                    console.log(error);
                    return false;
                }
            ).catch(e => {
                console.log(e);
                return false;
            });
        }
    }

    function listYuJaAccount() {
        return fetchWrapper.get({url: `${config.api.institution}/yuja/accounts`})
            .then((res) => {
                    if (res.success) {
                        return res.result;
                    } else {
                        notifyError(res.errorMessage);
                        return [];
                    }
                },
                (error) => {
                    notifyError("Can not load YuJa Account now. Please try again later.");
                    console.log(error);
                    return [];
                });
    }


    function listEventBanners() {
        return fetchWrapper.get({url: `${config.api.institution}/eventBanners`})
            .then((res) => {
                    if (res.success) {
                        return res.result.map(b => {
                            b.institutions = !!b.institutions ? b.institutions : [];
                            return b;
                        });
                    } else {
                        notifyError(res.errorMessage);
                        return [];
                    }
                },
                (error) => {
                    console.log(error);
                    return [];
                });
    }

    function saveEventBanner(eventBanner, isCreation=true) {
        let copy = JSON.parse(JSON.stringify(eventBanner));

        if (!copy.hasOwnProperty("institutions")) {
            copy.institutions = [];
        }
        return fetchWrapper.post({
            url: `${config.api.institution}/eventBanner`,
            body: copy
        }).then((res) => {
            if (res.success) {
                notifySuccess(isCreation ? "Successfully created event banner." : "Event banner updated successfully..")
                return true;
            } else {
                notifyError("Can not save Event Banner now. Please try again later.");
                console.log(res);
                return false;
            }
        }).catch(e => {
            notifyError("Can not save Event Banner now. Please try again later.");
            console.log(e);
            return false;
        });
    }

    function deleteEventBanner(id) {
        return fetchWrapper.delete({
            url: `${config.api.institution}/eventBanner/${id}`,
        }).then((res) => {
            if (res.success) {
                notifySuccess("Successfully deleted event.")
                return true;
            } else {
                notifyError("Can not delete Event Banner now. Please try again later.");
                console.log(res);
                return false;
            }
        }).catch(e => {
            notifyError("Can not delete Event Banner now. Please try again later.");
            console.log(e);
            return false;
        });
    }



    function listTimeZone() {
        return fetchWrapper.get({url: `${config.api.institution}/institution/timeZones`})
            .then((res) => {
                    if (res.success) {
                        return res.result;
                    } else {
                        notifyError(res.errorMessage);
                    }
                },
                (error) => {
                    notifyError("Can not load time zone now. Please try again later.");
                    console.log(error);
                });
    }


    function uploadImg(file, refreshFunc) {
        const fileName = `${getFormattedCurrentTime()}${getSuffix(file.name)}`;

        const cleanedFileName = removeSpecialCharacters(fileName);
        return fetchWrapper.put({
            url: `${config.api.institution}/institution/bgImg`,
            body: {originalName: cleanedFileName}
        }).then(result => {
            if (result.success) {
                return result.result;
            } else {
                notifyError(result.errorMessage);
                return "";
            }
        }).then(({putURL: url, getURL}) => {
            if (!url) {
                return "";
            }
            const requestOptions = {
                headers: {"Content-Type": file.type},
                method: 'PUT',
                body: file
            };
            return fetch(url, requestOptions).then(res=> {
                if (refreshFunc) {
                    refreshFunc(getURL);
                }
            });
        }).catch(err => {
            console.log(err);
            notifyError(SERVER_ERROR);
        });
    }


    function uploadLogoImg(file, refreshFunc) {
        const fileName = `${getFormattedCurrentTime()}${getSuffix(file.name)}`;

        const cleanedFileName = removeSpecialCharacters(fileName);
        return fetchWrapper.put({
            url: `${config.api.institution}/institution/logoImg`,
            body: {originalName: cleanedFileName}
        }).then(result => {
            if (result.success) {
                return result.result;
            } else {
                notifyError(result.errorMessage);
                return "";
            }
        }).then(({putURL: url, getURL}) => {
            if (!url) {
                return "";
            }
            const requestOptions = {
                headers: {"Content-Type": file.type},
                method: 'PUT',
                body: file
            };
            return fetch(url, requestOptions).then(res=> {
                console.log(res);
                if (refreshFunc) {
                    refreshFunc(getURL);
                }
            });
        }).catch(err => {
            console.log(err);
            notifyError(SERVER_ERROR);
        });
    }

    function saveSSODetails(configJson, integrationType) {
        return fetchWrapper.put(
            {
                url: `${config.api.institution}/institution/ssoconfig`,
                body: {
                    ssoConfigJsonString: JSON.stringify(configJson),
                    integrationType: integrationType
                }
            }
        ).then((result) => {
            if (result.success) {
                notifySuccess(SSO_UPDATE_SUCCESS);
                return true;
            } else {
                notifyError(result.errorMessage);
                return false;
            }
        }).catch(e => {
            notifyError(SSO_UPDATE_SUCCESS);
            console.log(e);
            return false;
        });
    }

    function getSSODetails() {
        return fetchWrapper.get(
            {
                url: `${config.api.institution}/institution/ssoconfig`,
                authorizeRequired: true
            }
        )
        .then(res => {
            if (res.success) {
                return res.result;
            }
        })
        .catch(err => {
            console.log(err);
            notifyError(LOAD_SSO_ERROR);
        });

    }

    function saveLMSConfig(configJson, integrationType) {
        setLoading(true);
        return fetchWrapper.put(
            {
                url: `${config.api.institution}/institution/lmsconfig`,
                body: {
                    lmsConfigJsonString: JSON.stringify(configJson),
                    integrationType: integrationType
                }
            }
        ).then((result) => {
            if (result.success) {
                notifySuccess(UPDATE_LMS_SUCCESS);
                return true;
            } else {
                notifyError(result.errorMessage);
                return false;
            }
        }).catch(e => {
            notifyError(UPDATE_LMS_ERROR);
            console.log(e);
            return false
        }).finally(() => {
            setLoading(false);
        });
    }

    function getSetting() {
        return fetchWrapper.get({
            url: `${config.api.institution}/institutions/platformsetting`,
            authorizeRequired: true
        }).then(res => {
            // console.log(res);
            if (res.success) {
                formatAPIResponseLog("getSetting", res.result);
                return res.result;
            } else {
                return {};
            }
        }).catch(err => {
            console.log(err);
            formatAPIErrorLog("getSetting", err);
            notifyError(LOAD_PLATFORM_SETTINGS_ERROR);
            return {};
        });
    }

    function updateSetting(setting) {
        return fetchWrapper.put({
            url: `${config.api.institution}/institutions/platformsetting`,
            body: {
                setting: setting,
            }
        }).then((result) => {
            // console.log(result);
            if (!result.success) {
                notifyError(result.errorMessage);
            }
            return result;
        }).catch(error => {
            notifyError(UPDATE_PLATFORM_SETTINGS_ERROR);
            console.log(error);
        });
    }

    function questionGenerate(videoLink, questionType) {
        return fetchWrapper.get({
            url: `${config.api.institution}/institution/question/gen?videoLink=${videoLink}&questionType=${questionType}`,
        }).then((result) => {
            // console.log(result);
            if (result.success) {
                return result.result;
            } else {
                notifyError(result.errorMessage);
                return "";
            }
        }).catch(error => {
            let errorObj = JSON.parse(error.message);
            if (errorObj.errorCode === "Y023") {
                notifyError(GEN_AI_INVALID_INST_ERROR);
            } else if (errorObj.errorCode === "Y024") {
                notifyError(GEN_AI_INVALID_VIDEO_ERROR);
            } else if (errorObj.errorCode === "Y025") {
                notifyError(GEN_AI_INVALID_VIDEO_LINK_ERROR);
            } else if (errorObj.errorCode === "Y026") {
                notifyError(GEN_AI_INVALID_VIDEO_LINK_DOMAIN_ERROR);
            } else if (errorObj.errorCode === "Y027") {
                notifyError(GEN_AI_INVALID_VIDEO_FILE_TOO_LARGE_ERROR);
            } else {
                notifyError(GENERATE_QUESTION_ERROR);
            }
            console.log(error);
            return "";
        });
    }


    function batchUpdateAdminManagers(userId, grantedInstitutions=[], canceledInstIds=[]) {
        return fetchWrapper.put({
            url: `${config.api.institution}/institution/adminManagers`,
            body: {
                id: userId,
                grantedInstitutions,
                canceledInstIds
            }
        }).then(result => {
            if (result.success) {
                return true;
            } else {
                notifyError(result.errorMessage);
                return false;
            }
        }).catch(error => {
            notifyError(SERVER_ERROR);
            console.log(error);
            return false;
        })
    }

    function removeSpecialCharacters(fileName) {
        const regex = /[^a-zA-Z0-9.]+/g;
        return fileName.replace(regex, '');
    }

    function getSuffix(imageName) {
        const regexp = /(.+)(\.\w+)/g;
        return regexp.exec(imageName)[2];
    }


    function getSupportCode () {
        return fetchWrapper.get({url: `${config.api.institution}/institution/supportCode`})
            .then((res) => {
                if (res.success) {
                    return res.result;
                } else {
                    console.error(res.errorMessage);
                    return "0";
                }
            }, (err) => {
                notifyError("Can not get support code now. Please try again later.");
                console.log(err);
                return "0";
            });
    }
}